module.exports = "/images/vendor/tui-image-editor/dist/svg/icon-c.svg?4c6ddeb14d1ba9fed2d7e6e312f52c17";